import { AlarmIcon } from "assets/icons";
import React from "react";
import styled from "styled-components";
import NewBadge from "./NewBadge";

interface GnbPushNotificationProps
  extends React.HTMLAttributes<HTMLDivElement> {
  hasNew: number;
  iconSize?: number;
}

const GnbPushNotification = ({
  hasNew,
  iconSize,
  ...rest
}: GnbPushNotificationProps) => {
  return (
    <WrapStyle {...rest}>
      <AlarmIcon style={{ width: iconSize, height: iconSize }} />
      {!!hasNew && <NewBadge count={hasNew} />}
    </WrapStyle>
  );
};

export default GnbPushNotification;

export const WrapStyle = styled.div`
  padding: 0.4rem;
  border-radius: 0.8rem;

  display: inline-flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.color.grey[300]};
  }

  &:active {
    svg {
      color: ${({ theme }) => theme.color.brick[500]};
    }
  }
`;
